import * as React from "react";
import supabase from "@clients/supabase";
import { useAuth } from "@store/auth";

const useAuthUser = () => {
  const userToken = useAuth((state) => state.userToken);
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState(null);

  React.useEffect(() => {
    supabase.auth.onAuthStateChange(async (event, session) => {
      setLoading(true);
    });
  }, []);

  React.useEffect(() => {
    if (!loading) return;
    if (!userToken) return;
    const fetchData = async () => {
      const {
        data: { user },
        error,
      } = await supabase.auth.getUser();

      if (error) {
        setData(null);
      }

      if (!user) {
        setData(null);
      }

      if (user) {
        const { data, error } = await supabase
          .from("user_profiles")
          .select(`id, first_name, last_name, phone, display_currency, email`)
          .eq("id", user.id)
          .single();

        setData({
          user: user,
          profile: data,
        });
      }

      setLoading(false);
    };

    fetchData();
  }, [loading, userToken]);

  return { ...data };
};

export default useAuthUser;
